var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4299",
    "data-name": "Group 4299",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 276,
    height: 89,
    viewBox: "0 0 276 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2997",
    "data-name": "Rectangle 2997",
    width: 276,
    height: 89,
    fill: "#e65847"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4851",
    "data-name": "Path 4851",
    d: "M0,61.751C0,35.519,7.528,25.8,27.641,25.8c18.82,0,27.524,8.432,27.524,26.7,0,19.439-6.7,27.637-20,28.925C17.879,83.064,24.7,99.693,14.233,99.693,4.941,99.693,0,84,0,61.751M42.7,48.987c0-9.134-4.352-11.125-10.586-11.125-5.881,0-10.586,1.991-10.586,11.125,0,7.378,2.352,11.008,10.586,11.008,7.292,0,10.586-3.4,10.586-11.008",
    transform: "translate(0 -10.693)",
    fill: "#e65847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4852",
    "data-name": "Path 4852",
    d: "M104.894,45.671c0-19.439,6.7-27.636,20-28.925C142.18,15.108,135.358,0,145.826,0c9.292,0,14.232,14.17,14.232,36.42,0,26.231-7.527,35.951-27.641,35.951-18.82,0-27.523-8.431-27.523-26.7M139.24,39c0-9.134-4.7-11.125-10.586-11.125-6.234,0-10.586,1.991-10.586,11.125,0,7.612,3.294,11.008,10.586,11.008,8.234,0,10.586-3.63,10.586-11.008",
    transform: "translate(-43.204 0)",
    fill: "#e65847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4853",
    "data-name": "Path 4853",
    d: "M210.694,45.671c0-19.439,6.7-27.636,20-28.925C247.98,15.108,241.158,0,251.626,0c9.292,0,14.233,14.17,14.233,36.42,0,26.231-7.527,35.951-27.641,35.951-18.82,0-27.523-8.431-27.523-26.7M245.04,39c0-9.134-4.7-11.125-10.586-11.125-6.234,0-10.586,1.991-10.586,11.125,0,7.612,3.294,11.008,10.586,11.008,8.234,0,10.586-3.63,10.586-11.008",
    transform: "translate(-86.781 0)",
    fill: "#e65847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4854",
    "data-name": "Path 4854",
    d: "M370.493,54.521C370.61,38.711,378.138,27,398.134,27c15.173,0,28.583,5.5,28.583,20.727,0,11.242-7.293,13.7-7.293,16.629s9.175,2.576,9.175,8.08c0,7.026-12.468,11.008-29.758,11.008-21.643,0-28.464-12.179-28.347-28.925m43.521-4.8c0-9.134-4.352-11.125-10.586-11.125-5.881,0-10.586,1.991-10.586,11.125,0,7.378,2.352,11.008,10.586,11.008,7.292,0,10.586-3.4,10.586-11.008",
    transform: "translate(-152.598 -11.191)",
    fill: "#e65847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4855",
    "data-name": "Path 4855",
    d: "M342.162,44.7a.588.588,0,0,0,1-.414V42.769C343.166,16.654,334.933,0,331.4,0c-2.54,0-7.515,8.638-10.1,23.215a1.178,1.178,0,0,0,.328,1.038Z",
    transform: "translate(-132.329)",
    fill: "#e65847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4856",
    "data-name": "Path 4856",
    d: "M319.948,54.536a.589.589,0,0,0-1,.358c-.288,3.27-.451,6.745-.451,10.407,0,27.286,8.233,29.6,11.762,29.6,2.965,0,9.249-1.639,11.183-18.342a1.178,1.178,0,0,0-.338-.966Z",
    transform: "translate(-131.181 -22.531)",
    fill: "#293462"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/LOGO.5d3f02b613c642d82a2315bc74e63b03.svg";
export { ForwardRef as ReactComponent };